import { FullPageLoader } from '@/components/loaders';
import { useTRPC } from '@/lib/trpc';
import { useQuery } from '@tanstack/react-query';
import { Navigate, Outlet } from 'react-router';

export function GlobalAdminRoute() {
  const trpc = useTRPC();
  const { data: me, isLoading } = useQuery(trpc.user.me.queryOptions());

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (!me?.isGlobalAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
